import Typography from '@hellodarwin/core/lib/components/common/typography';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const DisplayMoreText = styled(Typography) `
  cursor: pointer;
  text-decoration: underline;

  ${media.l `
    text-align: center;
  `}
`;
export const ApplicationFilesSidebarBlockContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  align-items: center;
`;
export const ApplicationFilesSidebarBlockCtas = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacing.md}px ${theme.spacing.lg}px`};
  gap: 12px;
  align-items: center;
`;
export const ApplicationFilesSidebarBlockCtas2 = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
